export enum HubspotFormPhase {
  STEP_ONE = 1,
  STEP_THREE = 3
}

export type HubspotUtm = {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
}

export type BaseHubspotFields = {
  firstname: string;
  lastname: string;
  email: string;
  userId?: string;
  signupToken?: string;
};

export type HubspotFirstPhase = BaseHubspotFields;

export type HubspotThirdPhase = BaseHubspotFields & {
  company: string;
  jobtitle: string;
};

export type HubspotFields = (HubspotFirstPhase | HubspotThirdPhase) & Partial<HubspotUtm>;

export enum ObjectTypeId {
  CONTACTS = '0-1',
}

export  type HubspotFieldKey =
  keyof Omit<HubspotFields, "userId" | "signupToken">
  | "hub_auth0_id"
  | "hub_signup_token";

export type HubspotFieldPayload = {
  objectTypeId: ObjectTypeId;
  name: HubspotFieldKey;
  value: string;
}

export type FreemiumFields = HubspotFirstPhase & Partial<HubspotThirdPhase>;
